import styled from 'styled-components'

export const IconWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  justify-content: center;
  margin: 0 0 20px;
  min-height: 100px;
`
